<template>
  <v-app id="inspire">

    <Snackbar />

    <v-app-bar app>
      <v-spacer />
      <v-toolbar-title>SILIKAI</v-toolbar-title>
      <v-spacer />
    </v-app-bar>

    <v-navigation-drawer app permanent>
      <v-list>
        <v-list-item link :to="'/home'">
          <v-list-item-avatar>
            <v-img :contain="true" position="right center" transition="none" src="@/assets/silam-logo.png" />
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="text-h6">
              {{ user.full_name || 'John Doe' }}
            </v-list-item-title>
            <v-list-item-subtitle>{{ user.username || 'username' }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>

      <v-card>
        <v-list dense nav>
          <template v-for="section in routes">
            <div v-if="!section.children" :key="section.name">
              <v-list-item v-model="section.active">
                <v-list-item-icon>
                  <v-icon v-text="section.icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="section.nameToShow"></v-list-item-title>
              </v-list-item>
            </div>

            <div v-else>
              <v-list-group v-model="section.active" :prepend-icon="section.icon" no-action>
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title v-text="section.nameToShow"></v-list-item-title>
                  </v-list-item-content>
                </template>
                <v-list-item v-for="child in section.children" :key="child.name" link v-show="child.show">
                  <v-list-item-icon>
                    <v-icon v-text="child.icon"></v-icon>
                  </v-list-item-icon>
                  <v-list-item-content v-on:click="$router.push({ name: child.name }).catch(e => {
                    if (
                      e.name !== 'NavigationDuplicated' &&
                      !e.message.includes('Avoided redundant navigation to current location')
                    ) {
                      console.log(e)
                    }
                  });">
                    <v-list-item-title v-text="child.nameToShow"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

              </v-list-group>
            </div>
          </template>
        </v-list>
      </v-card>

      <template v-slot:append>
        <div class="pa-2">
          <v-btn block dark v-on:click="logout">
            <v-icon>mdi-logout</v-icon> Logout
          </v-btn>

        </div>
      </template>
    </v-navigation-drawer>

    <v-main>
      <router-view />
    </v-main>

    <v-footer app fluid>
      <v-container fill-height fluid class="ma-0 pa-0">
        <v-row class="ma-0 pa-0">
          <v-col cols="8" class="ma-0 pa-0">
            <v-card flat tile class="flex mx-0 text-left">
              <v-card-text class="py-0 secondary--text">
                SILICONAS SILAM S.A. &copy; 2023
              </v-card-text>
            </v-card>
          </v-col>
          <v-col class="ma-0 pa-0" />
          <v-col cols="2" class="ma-1 mr-3 pa-0">
            <a href="https://www.tecnalia.com" target="_blank">
              <v-img :contain="true" max-height="1.2em" position="right center" transition="none"
                src="@/assets/logo.svg" />
            </a>
          </v-col>
          <v-btn v-show="buttonGoToTop" color="accent" small absolute bottom right @click="goToTop">
            <v-icon>mdi-arrow-up</v-icon>
            Ir al inicio
          </v-btn>
        </v-row>
      </v-container>
    </v-footer>
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { pages } from "@/router/index";
import Snackbar from "@/components/util/Snackbar";

export default {
  components: { Snackbar },

  name: 'Template',
  created: function () {
    return this.$store.dispatch('viewMe');
  },
  computed: {
    ...mapGetters({ user: 'stateUser' }),
    routes() {
      let navigationRoutes = []
      for (let i in pages) {
        if (pages[i].show) {
          navigationRoutes.push(pages[i])
        }
      }
      return navigationRoutes
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
    ...mapActions(['deleteUser']),
    async logout() {
      await this.$store.dispatch('logOut');
      await this.$store.commit('isLoggedIn', false);
      this.$router.push('/login');
    },
    async deleteAccount() {
      try {
        await this.deleteUser(this.user.id);
        await this.$store.dispatch('logOut');
        this.$router.push('/');
      } catch (error) {
        console.error(error);
      }
    },
    handleScroll: function () {
      if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
        this.buttonGoToTop = true;
      } else {
        this.buttonGoToTop = false;
      }
    },
    goToTop: function () {
      document.documentElement.scrollTop = 0;
    },
  },
  data() {
    return {
      buttonGoToTop: false
    }
  }
}
</script>

<style>
h1 {
  color: #f55 !important;
}
</style>